var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { GAService } from '../../../../services/GAService';
import { mainFormSlice } from '../../../../store/mainForm/mainForm.slice';
import { initialDataSlice } from '../../../../store/initialData/initialData.slice';
import { MAIN_FORM_STEPS } from '../../../../store/mainForm/mainForm.types';
import { useGAEventMeta } from '../../../../hooks/useGAEventMeta.hook';
import { BugsnagService } from '../../../../services/Bugsnag.service';
var mapStateToProps = function (state) { return ({
    step: mainFormSlice.selectors.getActiveStep(state),
    mortgageCaseMeta: mainFormSlice.selectors.getMortgageCaseMeta(state),
    placementId: initialDataSlice.selectors.getPlacementId(state),
    preferredChannel: mainFormSlice.selectors.getPreferredChannel(state),
}); };
function RawWizardFormStepWatcher(_a) {
    var step = _a.step, placementId = _a.placementId, mortgageCaseMeta = _a.mortgageCaseMeta, preferredChannel = _a.preferredChannel;
    var gaEventMeta = useGAEventMeta();
    var caseId = mortgageCaseMeta.caseId;
    useEffect(function () {
        BugsnagService.emitVirtualNavigationEvent("Customer enters MR1/".concat(step));
    }, [step]);
    var _b = useState(false), isFLeadCompleted = _b[0], setIsFLeadCompleted = _b[1];
    useEffect(function () {
        setIsFLeadCompleted(false);
    }, [caseId]);
    useEffect(function () {
        GAService.onVirtualPageEnter("/mainRoute/".concat(step), gaEventMeta);
        if (step === MAIN_FORM_STEPS.SUCCESS_SCREEN && !isFLeadCompleted) {
            setIsFLeadCompleted(true);
            GAService.onLeadCreated(placementId, __assign(__assign({}, gaEventMeta), { preferredChannel: preferredChannel }));
        }
    }, [step, gaEventMeta, preferredChannel]);
    return null;
}
var WizardFormStepWatcher = connect(mapStateToProps)(RawWizardFormStepWatcher);
export default WizardFormStepWatcher;
